<script setup lang="ts">
import PageHeader from '../../../components/clients/common/PageHeader.vue';
import PageFooter from '../../../components/clients/common/PageFooter.vue';
import { ref } from 'vue';
import { useStateStore } from '../../../stores/state.store';
import BingoBoard from '@/components/clients/bingo/BingoBoard.vue';

const stateStore = useStateStore();

const mainColor = ref(stateStore.getColors.mainColor);
const backgroundColor = ref(stateStore.getColors.backgroundColor);
</script>

<template>
  <div class="bingo-container">
    <PageHeader
      :main-color="mainColor"
      :background-color="backgroundColor"
      header-text="Bingo"
    />
    <div class="bingo">
      <BingoBoard />
    </div>
    <PageFooter />
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styleConstans';

.bingo-container {
  background-color: v-bind(backgroundColor);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.bingo {
  flex: 1 0 auto;
  position: relative;
  display: flex;
  padding-top: 110px;

  @media (max-width: $media-phone) {
    padding-top: 70px;
  }
}
</style>
